import Column from '@app/components/layout/Column'
import { YesNoToggle } from '@app/components/core/toggle/YesNoToggle'
import { useTranslations } from '@i18n/useLanguage'
import { useCallback, useEffect, useState } from 'react'
import { useClient } from '@based/sdk/react'
import { useToast } from '@app/util/hooks/useToast'
import { useEditContainerClose } from '../shared/useEditContainerClose'
import { FieldEditActions } from '../shared/FieldEditActions'

export type SearchingForMembersEditProps = {
  initiativeId: number
  searchingForMembers: boolean
}

export const SearchingForMembersEdit = ({
  initiativeId,
  searchingForMembers,
}: SearchingForMembersEditProps) => {
  const close = useEditContainerClose()
  if (!close) {
    throw new Error(
      'SearchingForMembersEdit requires an EditContainer ancestor',
    )
  }
  const client = useClient()
  const { showFailToast, showSuccessToast } = useToast()
  const t = useTranslations().app.common

  const [yes, setYes] = useState(searchingForMembers)

  useEffect(() => {
    setYes(searchingForMembers)
  }, [searchingForMembers])

  const save = useCallback(() => {
    void client
      .call('edit-initiative', {
        id: initiativeId,
        value: yes
          ? { searchingForMembers: true }
          : { searchingForMembers: false, searchingForMembersDescription: '' },
      })
      .then((success) => {
        if (success) {
          showSuccessToast(t.toastSuccess)
          close()
        } else {
          showFailToast()
        }
      })
      .catch(() => showFailToast())
  }, [
    client,
    initiativeId,
    yes,
    close,
    showFailToast,
    showSuccessToast,
    t.toastSuccess,
  ])

  return (
    <Column gap="1rem" alignItems="stretch">
      <YesNoToggle yesSelected={yes} setYesSelected={setYes} />
      <FieldEditActions onCancel={close} onSave={save} />
    </Column>
  )
}
